import { render } from "./product_details.vue?vue&type=template&id=286437fb"
import script from "./product_details.vue?vue&type=script&lang=js"
export * from "./product_details.vue?vue&type=script&lang=js"

import "./product_details.vue?vue&type=style&index=0&id=286437fb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__